import api from './api';

const API_URL = '/api/events';
const EXTERNAL_EVENTS_API_URL = '/api/external/events';
const DEFAULT_LIST_PAGE = 0;
const DEFAULT_LIST_SIZE = 100;

export const createEvent = async (data) => {
  const response = await api.post(API_URL, data);
  return response.data;
};

export const copyExternalEvent = async (externalEventId, data) => {
  const response = await api.post(`${EXTERNAL_EVENTS_API_URL}/copy`, {
    externalEventId,
    event: data,
  });
  return response.data;
};

export const updateEvent = async (id, data) => {
  const response = await api.put(`${API_URL}/${id}`, data);
  return response.data;
};

export const updateEventResult = async (id, result, mainResult = null) => {
  const payload = { result };
  if (mainResult) {
    payload.mainResult = mainResult;
  }
  const response = await api.patch(`${API_URL}/${id}/result`, payload);
  return response.data;
};

export const archiveEvent = async (id) => {
  const response = await api.post(`${API_URL}/${id}/archive`);
  return response.data;
};

export const deleteEvent = async (id, force = false) => {
  const params = force ? { force: true } : {};
  await api.delete(`${API_URL}/${id}`, { params });
};

export const getEvents = async (filters = null) => {
  const response = await api.get(API_URL, {
    params: buildEventListParams(filters),
  });
  return filters ? response.data : (response.data?.content || []);
};

export const getEvent = async (id) => {
  const response = await api.get(`${API_URL}/${id}`);
  return response.data;
};

export const getEventChallenges = async (id) => {
  const response = await api.get(`${API_URL}/${id}/challenges`);
  return response.data;
};

export const searchExternalEvents = async (competition) => {
  const response = await api.get(EXTERNAL_EVENTS_API_URL, {
    params: { competition },
  });
  return response.data;
};

// ===================================================================================================================
// = Implementation
// ===================================================================================================================

const buildEventListParams = (filters) => {
  const source = filters || { page: DEFAULT_LIST_PAGE, size: DEFAULT_LIST_SIZE };
  return Object.entries(source).reduce((params, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      params[key] = value;
    }
    return params;
  }, {});
};
